<template>
  <v-container fluid>
    <v-card
        class="mx-auto px-4"
        elevation="1"
        style="min-width: 500px; max-width: 1000px"
    >
      <v-card-title
          class="justify-center mb-4 text-md-h4 text-h5 text-decoration-underline"
      >
        {{ $t("pleaseChooseYourMembership") }}
      </v-card-title>
      <memberships @membership-was-chosen="membershipWasChosen"/>
      <br/>
      <v-row>
        <v-col
            :sm="9"
            cols="12"
        >
          <div class="d-flex">
                <span class="mt-1">
                  {{ $t("connectiosOverStandardToBuy") }}
                </span>
            <v-text-field
                v-model="chosenConnectionsOverStandard"
                :value="0"
                class="ml-3 mt-0 pt-0"
                hide-details
                single-line
                dense
                type="number"
                :min="0"
                style="max-width: 40px"
            ></v-text-field>
            <div class="ml-1" style="margin-top: 1px">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on"> mdi-help-circle-outline</v-icon>
                </template>
                {{ $t("toolTips.connectionsOver") }}
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col
            :sm="3"
            cols="12"
            class="text-right mt-n5 mt-sm-0"
        >
              <span v-if="totalPrice !== 0"
              >{{ $t("quickMembershipResume.monthlyPrice") }}
                {{ totalPrice }} $</span
              >
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-5 pb-5">
        <v-spacer/>
        <v-tooltip
            bottom
            :disabled="chosenMembershipName !== '' && totalPrice === 0"
        >
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-btn
                  color="success"
                  class="ml-3"
                  @click="continueClicked"
                  :loading="isButtonLoading"
                  :disabled="!chosenMembershipName"
              >
                {{ totalPrice === 0 ? $t("buttons.continue") : $t("buttons.toPay") }}
                <template v-slot:loader>
                            <span class="custom-loader">
                              <v-icon light>mdi-cached</v-icon>
                            </span>
                </template>
              </v-btn>
            </div>
          </template>
          <span v-if="!chosenMembershipName">
                      {{ $t("toolTips.chooseMembership") }}
                    </span>
          <span v-else-if="totalPrice !== 0">
                      {{ $t("toolTips.redirectToPaymentGate") }}
                    </span>
        </v-tooltip>
        <v-spacer/>
      </v-row>

      <v-snackbar right top app color="error" v-model="continueClickedError">
        {{ $t("notificationSnackbars.redirectToStripeUnsuccessful") }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="continueClickedError = false">
            {{ $t("buttons.close") }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import {CONNECTIONS_OVER_MEMBERSHIP} from "../../../enums/membership/typeOfMembership.js";
import Memberships from "./Memberships.vue";
import {getNewSubscriptionLink} from "../../../backendService.js";

export default {
  components: {Memberships},
  data() {
    return {
      chosenConnectionsOverStandard: 0,
      chosenMembershipName: "",
      chosenMembershipPrice: 0,
      isButtonLoading: false,
      continueClickedError: false,
    };
  },
  computed: {
    totalPrice() {
      return this.chosenMembershipPrice + this.chosenConnectionsOverStandard * CONNECTIONS_OVER_MEMBERSHIP.price;
    },
  },
  methods: {
    async continueClicked() {
      this.isButtonLoading = true;
      const response = await getNewSubscriptionLink(this.chosenMembershipName, this.chosenConnectionsOverStandard);
      if (!response) {
        this.continueClickedError = true;
        // Stop showing loading button only when there is an error (no redirect)
        this.isButtonLoading = false;
      } else {
        window.location.href = response;
      }
    },
    membershipWasChosen(chosenMembershipName, chosenMembershipPrice) {
      this.chosenMembershipName = chosenMembershipName;
      this.chosenMembershipPrice = chosenMembershipPrice;
    },
  },
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
